// | ------------------------------------------------------------------------
// | Contact Page
// | ------------------------------------------------------------------------

import validate from "jquery-validation";

// | Map --------------------------------------------------------------------

import "./components/jquery.magnific-popup";
import "./components/propertyMap";

// | ------------------------------------------------------------------------

$("#getquoteform").validate({
  submitHandler: function (form) {
    form.submit();
  },
  rules: {
    name: "required",
    email: {
      required: true,
      email: true,
    },
    contact: "required",
    phone: "required",
    enquiry: "required",
  },
});
//console.log("validaterun");
